import debugLog from 'utils/debugLog'

export enum DataLayerEvents {
  ChatBotOpened = 'chatbotOpened',
  ChatBotInteracted = 'chatbotInteracted',
  ChatBotFeedbackUseCasePositive = 'chatbotFeedbackUsecasePositive',
  ChatBotFeedbackUseCaseNegative = 'chatbotFeedbackUsecaseNegative',
}

const dataLayerPushEvent = (event: string, payload: object = {}) => {
  const data = { event, ...payload }
  if (window?.dataLayer) {
    const { dataLayer } = window

    dataLayer.push(data)
  }

  debugLog('Pushing data to dataLayer', data)
}

export default dataLayerPushEvent
